module.exports = __webpack_public_path__ + "static/media/user.9a7330fb.svg";